import { EditablePropertyData } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectEditablePropertyDataEntities } from './editablePropertyDataSelectors.ts';

export const selectManualAdjustmentsEntities = createSelector(
  [selectEditablePropertyDataEntities],
  (editablePropertyDataEntities) =>
    Object.fromEntries(
      Object.entries(editablePropertyDataEntities)
        .filter(([id, _editableData]) => id !== 'subject')
        .map(([id, editableData]) => [
          id,
          { id, ...(editableData as EditablePropertyData).manualAdjustments },
        ]),
    ),
);

export const selectManualAdjustmentsById = createSelector(
  [selectManualAdjustmentsEntities, (_state, id: string) => id],
  (manualAdjustmentsEntities, id) => manualAdjustmentsEntities[id],
);

export const selectAllManualAdjustments = createSelector(
  [selectManualAdjustmentsEntities],
  (manualAdjustmentsEntities) => Object.values(manualAdjustmentsEntities),
);
